import { module } from 'modujs';
const serialize = require('form-serialize');


export default class extends module {
    constructor(m) {
        super(m);
        this.form = this.el;
        this.submitButton = this.el.querySelector( "[type=submit]");
        this.formMessage = this.el.querySelector( '[data-form-message]' );
        this.formControls = [...this.el.querySelectorAll( '[data-module-form-control]')];


        this.form.addEventListener( 'submit', e => {
            e.preventDefault();
            this.formMessage.classList.remove( ...this.formMessage.dataset.errorClass.split( ' ' ) );
            this.formMessage.classList.remove( ...this.formMessage.dataset.successClass.split( ' ' ) );
            this.formMessage.textContent = '';
            if( ! this.validate() ) return;
            this.toggleLoading();
            // ...
        });
    }

    toggleLoading( op = 'add' ){
        this.form.classList[ op === 'add' ? 'add' : 'remove' ]( 'pointer-events-none' );
        this.submitButton.classList[ op === 'add' ? 'add' : 'remove' ]( ...'cursor-not-allowed loading'.split( ' ') );
    }

    validate(){
        this.isValid = true;
        this.firstError = false;
        this.formControls.forEach( e => {
            let moduleName = e.dataset.moduleFormControl;
            if( ! this.modules.FormControl[ moduleName ].validate() ) {
                this.isValid = false;
                if( ! this.firstError ) {
                    this.firstError = e;
                    this.modules.FormControl[ moduleName ].input.focus();
                }
            }
        });
        if( ! this.isValid ) {
            this.call('scrollTo', { target: this.firstError, options: { duration: 0.5, offset: -( document.querySelector( 'header' ).offsetHeight + 20 ) } }, 'Scroll');
        }
        return this.isValid;
    }

}
